// Warm only on explicit search intent; isolate short-lived HTML by market and asset revision.
(()=>{
  const node=document.getElementById('rr-search-navigation-config');
  if(!node)return;
  const config=JSON.parse(node.textContent),pending=new Map();
  const scope=JSON.stringify([config.scope,config.country,config.currency,config.locale]);
  const key=url=>{const normalized=new URL(url,location.origin);normalized.searchParams.delete('preview_theme_id');normalized.searchParams.sort();return 'rr-search-warm:'+scope+normalized.pathname+normalized.search;};
  window.RRSearchNavigation={read(url){
    try {const value=JSON.parse(sessionStorage.getItem(key(url))||'null');if(value&&Date.now()-value.time>=0&&Date.now()-value.time<60000)return value.html;}catch{}
    return null;
  }};
  const warm=url=>{
    if(pending.has(url.href)||window.RRSearchNavigation.read(url))return;
    pending.set(url.href,fetch(url,{credentials:'same-origin',signal:AbortSignal.timeout(5000)})
      .then(response=>response.ok?response.text():null).then(html=>{if(html)try{sessionStorage.setItem(key(url),JSON.stringify({time:Date.now(),html}));}catch{}}).catch(()=>{}));
  };
  const intent=event=>{
    const link=event.target.closest?.('.shopify-section--header a[href]');
    if(!link||new URL(link.href).pathname!==config.search||location.pathname===config.search||navigator.connection?.saveData)return;
    const catalog=new URL(config.collection,location.origin);catalog.searchParams.set('section_id','rr-search-catalog');catalog.searchParams.set('page','1');warm(catalog);
    const facets=new URL(config.collection,location.origin);facets.searchParams.set('filter.v.availability','1');facets.searchParams.set('rr_availability','selected');
    const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)facets.searchParams.set('preview_theme_id',preview);
    facets.searchParams.set('section_id','rr-search-facets');warm(facets);
  };
  // Preserve the current header until native navigation replaces the document.
  window.addEventListener('click',event=>{
    if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const link=event.target.closest?.('a[href]');
    if(!link||link.hasAttribute('download')||(link.target&&link.target!=='_self'))return;
    const destination=new URL(link.href,location.href),current=new URL(location.href);
    if(destination.origin!==current.origin||(destination.pathname===current.pathname&&destination.search===current.search))return;
    if(destination.pathname===config.search&&link.matches?.('[data-rr-search-page-link]')) {
      try {sessionStorage.setItem('rr-search-drawer-open','true');}catch{}
    }
  });
  document.addEventListener('pointerover',intent,{passive:true});
  document.addEventListener('focusin',intent);
})();
